export default {
  REPLACE_FILMS: 'update-films',
  APPEND_FILMS: 'append-films',
  UPDATE_FILM_DETAILS: 'update-film-details',
  UPDATE_IS_FETCHING: 'update-is-fetching',
  SET_QUERY: 'set-query',
}
